import styled from 'styled-components'

import VariantText from 'components/UIKit/VariantText'

const Note = styled(VariantText)`
  text-align: center;
`

export default Note
